export const AUTH_PROVIDER_STATE = Object.freeze({
  PASSWORD_ONLY: "PASSWORD_ONLY",
  APPLE_ONLY: "APPLE_ONLY",
  PASSWORD_AND_APPLE: "PASSWORD_AND_APPLE",
  UNKNOWN: "UNKNOWN",
});

export function getAuthProviderIds(firebaseUser) {
  return Array.from(
    new Set(
      (firebaseUser?.providerData || [])
        .map((provider) => String(provider?.providerId || "").trim())
        .filter(Boolean)
    )
  );
}

export function getAuthProviderState(firebaseUser) {
  const providers = getAuthProviderIds(firebaseUser);
  const hasPassword = providers.includes("password");
  const hasApple = providers.includes("apple.com");

  if (hasPassword && hasApple) return AUTH_PROVIDER_STATE.PASSWORD_AND_APPLE;
  if (hasPassword) return AUTH_PROVIDER_STATE.PASSWORD_ONLY;
  if (hasApple) return AUTH_PROVIDER_STATE.APPLE_ONLY;
  return AUTH_PROVIDER_STATE.UNKNOWN;
}

export function hasPasswordAuthProvider(firebaseUser) {
  return getAuthProviderIds(firebaseUser).includes("password");
}

export function hasAppleAuthProvider(firebaseUser) {
  return getAuthProviderIds(firebaseUser).includes("apple.com");
}

export function getAccountProviderCapabilities(firebaseUser) {
  const state = getAuthProviderState(firebaseUser);
  const hasPassword = hasPasswordAuthProvider(firebaseUser);
  const hasApple = hasAppleAuthProvider(firebaseUser);
  return {
    state,
    hasPassword,
    hasApple,
    canChangePassword: hasPassword,
    canChangeEmail: hasPassword,
    canReauthenticateWithApple: hasApple,
    canDeleteAccountInCurrentFlow: state !== AUTH_PROVIDER_STATE.UNKNOWN,
  };
}

export function isAppleAuthUser(firebaseUser) {
  return hasAppleAuthProvider(firebaseUser);
}

export function requiresEmailVerificationForUser(firebaseUser, profileData = {}) {
  if (isAppleAuthUser(firebaseUser)) return false;
  return profileData?.requiresEmailVerification === true;
}
